export default "__VITE_PUBLIC_ASSET__bd4d4757__"